import { createFileRoute, redirect } from '@tanstack/react-router';
import { BILLING_CHARGE_BASE_PATH } from '../../../../features/billing/charge/billing-charge-routing';

export const Route = createFileRoute('/_app/_clearing-core/billing/')({
  beforeLoad: () => {
    throw redirect({ to: BILLING_CHARGE_BASE_PATH });
  },
  preload: false,
});
